import { useEffect } from 'react';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { submitPql } from '../../pql/submitPql';
import { trackTalkToSalesPql } from '../../utils/metricUtils';
import { VerticalAssignableModal } from '../VerticalAssignableModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssignableModal = ({
  handleIframeSizeChange = () => {},
  hideBackground = false,
  onClose,
  _overrideModalHeaderText,
  _overrideCommunicationMethodKey,
  isFreePortal,
  upgradeData,
  modalRoot,
  repInfo
}) => {
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'viewed'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      repName: getRepName(repInfo)
    }));
    void submitPql(Object.assign({}, upgradeData, {
      isRetail: false,
      isAssignable: true,
      repInfo
    }));
    trackTalkToSalesPql(upgradeData.app);
  }, [upgradeData, repInfo]);
  return /*#__PURE__*/_jsx(VerticalAssignableModal, {
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    onClose: onClose,
    _overrideModalHeaderText: _overrideModalHeaderText,
    _overrideCommunicationMethodKey: _overrideCommunicationMethodKey,
    upgradeData: upgradeData,
    modalRoot: modalRoot,
    repInfo: repInfo,
    isFreePortal: isFreePortal
  });
};